/* esm.sh - date-fns@4.1.0/getDefaultOptions */
import{getDefaultOptions as t}from"./_lib/defaultOptions.mjs";function e(){return Object.assign({},t())}var o=e;export{o as default,e as getDefaultOptions};
//# sourceMappingURL=getDefaultOptions.mjs.map